<template>
  <div>
    <page-header :title="$t('Product Catalog')">
      <vs-alert class="w-1/2" active="true" color="warning" icon-pack="feather" icon="icon-alert-triangle" v-if="merchantStatus === 'on_hold'">
        {{$t('Your account is')}} <b>{{$t('On hold')}}</b> {{$t('due to inactivity. Please, use the chat icon to talk to our support team and reactivate your account.')}}
      </vs-alert>
      <vs-dropdown v-else
        vs-trigger-click
        ref="card"
        class="dropdown dd-actions cursor-pointer"
      >
        <shipblu-button :iconStyle="{LeftIconName: 'add', LeftIconLibrary: 'material', iconPosition: 'left'}"/>
        <vs-dropdown-menu class="add-shipment-dropdown">
          <vs-dropdown-item class="step-selector-2" @click="openProductModal('New Product')">
            <span class="flex items-center text-blue-900 hover:text-primary">
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="mr-2"
              />
              <span>{{$t('New Product')}}</span>
            </span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="uploadFiletype('uploadFulfillment')" class="new-img">
            <div class="flex" style="position: revert;">
            <span class="flex items-center">
              <feather-icon
                icon="UploadIcon"
                svgClasses="h-4 w-4"
                class="mr-2"
              />
              <span>{{$t('Upload Multiple Orders')}}</span>
            </span>
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </page-header>

    <div class="flex my-4">
      <div v-for="(tab, index) in tabs" :key="index" class="sm:w-auto w-full">
        <p
          @click="changeTab(tab.value)"
          :class="`font-medium whitespace-nowrap text-center md:text-[18px] text-[16px] sm:py-[11px] xl:px-[75px] lg:px-[50px] md:px-[25px] px-[17px] p-3 rounded-t-[5px] cursor-pointer leading-[22px] ${tab.value === activeTab ? 'text-primary border-0 border-b-2 border-solid border-primary bg-carte-blanche' : 'border-0 border-b border-solid border-steam text-industrial-revolution'}`"
        >
          {{ $t(tab.name) }}
        </p>
      </div>
    </div>
    
    <shipblu-table
      :sst="true"
      multiple
      v-model="selected"
      pagination
      :max-items="maximumItems"
      @search="handleSearch"
      @keyup.enter.native="handleSearch"
      search
      :data="products"
      :tableLoader="tableLoader"
    >
      <template v-if="activeTab === 'unarchive'" slot="header">
        <div class="flex flex-wrap items-center gap-3 whitespace-nowrap">
          <div v-if="merchantStatus === 'active'">
            <shipblu-button size="small" :textButton="$t('Create Stock Request')" :iconStyle="{LeftIconName: 'ShoppingCartIcon', LeftIconLibrary: 'feather', iconPosition: 'left'}" @click="stockModal = true" :disabled="selectedFlag ? false : true"/>
          </div>
          <div v-if="merchantStatus === 'active'">
            <shipblu-button size="small" :textButton="$t('Create Stock Recall')" :iconStyle="{LeftIconName: 'ShoppingCartIcon', LeftIconLibrary: 'feather', iconPosition: 'left'}" @click="addStockRecall()" :disabled="selectedFlag ? false : true"/>
          </div>
          <print-label-button class="flex self-center" :selected="selected"></print-label-button>
          <div class="cursor-pointer vs-con-loading__container float-right" id="download-btn-loading">
            <shipblu-button size="small" :textButton="'Download Catalog'" @click="downloadCatalog()"/>
          </div>
        </div>
      </template>
      <template slot="thead">
        <shipblu-th>{{$t('Product Image')}}</shipblu-th>
        <shipblu-th>{{$t('SBSIN')}}</shipblu-th>
        <shipblu-th>{{$t('SKU')}}</shipblu-th>
        <shipblu-th>{{$t('Name')}}</shipblu-th>
        <shipblu-th>{{$t('Description')}}</shipblu-th>
        <shipblu-th>{{$t('Size')}}</shipblu-th>
        <shipblu-th>{{$t('Color')}}</shipblu-th>
        <shipblu-th>{{$t('Dimensions')}}</shipblu-th>
        <shipblu-th>{{$t('Current Inventory')}}</shipblu-th>
        <shipblu-th>{{$t('Supplier')}}</shipblu-th>
        <shipblu-th>{{$t('Actions')}}</shipblu-th>
      </template>
      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <shipblu-td class="sm:hidden block col-span-2 p-0 order-3">
            <!-- line -->
            <p style="background-color: #DCDCDC;height: 1px;"></p>
          </shipblu-td>

          <shipblu-td class="order-4" :data="data[indextr].image">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Product Image')}}</p>
            <img :src=" data[indextr].image " class="w-10 h-10"/>
          </shipblu-td>

          <shipblu-td class="order-5" :data="data[indextr].shipBluInventoryID">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('SBSIN')}}</p>
            {{ data[indextr].id }}
          </shipblu-td>

          <shipblu-td class="order-13" :data="data[indextr].sku">
            <div class="flex sm:static absolute top-3 gap-2 items-start justify-start transform-50" v-on:click.stop>
              <p v-on:click.stop class="sm:text-base text-lg flex gap-1 items-start justify-center">
                <span>{{ data[indextr].sku }}</span>
                <shipblu-icon @click="common.copied(data[indextr].sku)" iconLibrary="material" iconClass="text-grey hover:text-primary text-xl cursor-pointer sm:hidden block" iconName="content_copy"></shipblu-icon>
              </p>
            </div>
          </shipblu-td>

          <shipblu-td class="order-6" :data="data[indextr].name">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Name')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].name }}</p>
          </shipblu-td>

          <shipblu-td class="order-7" :data="data[indextr].description">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Description')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].description }}</p>
          </shipblu-td>

          <shipblu-td class="order-8" :data="data[indextr].size">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Size')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].size }}</p>
          </shipblu-td>

          <shipblu-td class="order-9" :data="data[indextr].color">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Color')}}</p>
            <div class="color-container h-6 sm:block flex items-center gap-2">
              <div class="w-full h-full" :style="`background-color:${data[indextr].color}`"></div>
              <p class="sm:mt-2 mt-0" v-if="!data[indextr].color.includes('#')">{{data[indextr].color}}</p>
            </div>
          </shipblu-td>

          <shipblu-td class="order-10" :data="data[indextr].dimensions" style="direction: ltr;">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Dimensions')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].d_length }} x {{ data[indextr].d_width }} x {{ data[indextr].d_height }}</p>
          </shipblu-td>

          <shipblu-td class="order-11" :data="data[indextr].currentInventoryLevel">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Current Inventory')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].locations.reduce((sum, { stored_quantity }) => sum + stored_quantity, 0) }}</p>
          </shipblu-td>

          <shipblu-td class="order-12" :data="data[indextr].supplier">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Supplier')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].supplier }}</p>
          </shipblu-td>

          <shipblu-td class="order-2" style="vertical-align: middle;">
            <div class="md:text-center text-right">
              <vs-dropdown
                vs-trigger-click
                @click="selected = []"
                class="dd-actions cursor-pointer"
              >
                <span class="material-symbols-outlined text-2xl">more_horiz</span>
                <vs-dropdown-menu style="width: 190px">
                  <vs-dropdown-item v-if="activeTab === 'unarchive'" @click="openProductModal('Edit Product', data[indextr])">
                    <span class="flex items-center">
                      <feather-icon
                        icon="EditIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('Edit')}}</span>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="activeTab === 'unarchive' && (data[indextr].locations.reduce((sum, { stored_quantity }) => sum + stored_quantity, 0) === 0)" @click="archiveProduct(data[indextr])">
                    <span class="flex items-center">
                      <shipblu-icon iconLibrary="material" iconClass="text-lg cursor-pointer mr-2" iconName="archive"></shipblu-icon>
                      <span>{{$t('Archive')}}</span>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="activeTab === 'archive'" @click="unarchiveProduct(data[indextr])">
                    <span class="flex items-center">
                      <shipblu-icon iconLibrary="material" iconClass="text-lg cursor-pointer mr-2" iconName="unarchive"></shipblu-icon>
                      <span>{{$t('Unarchive')}}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" @changePageSize="changePageSize" />
    <print-product-barcode :selected="selected"/>
    <add-stock-request :selected="selected" @selected="selected = $event" :stockModal="stockModal" @stockModal="stockModal = $event" type="New Stock Request" :stockRequest="stockRequest"></add-stock-request>
    <add-product :productModal="productModal" @productModal="productModal = $event" @loadProductCatalog="loadProductCatalog" :type="type" :product="product"></add-product>
    <upload-shipments-modal :uploadFileType="uploadFileType" :uploadShipmentsModal="uploadShipmentsModal" @uploadShipmentsModal="uploadShipmentsModal = $event" />
  </div>
</template>

<script>
import AddProduct from './components/AddProduct.vue'
import common  from '@/assets/utils/common'
import {sendFulfillmentRequest} from '../../../http/axios/requestHelper.js'
import ShipbluTable from '../../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../../layouts/components/ShipBluTd.vue'
import AddStockRequest from './components/AddStockRequest.vue'
import PrintLabelButton from '../../headOfFleet/components/PrintLabelButton.vue'
import PrintProductBarcode from '../components/PrintProductBarcode.vue'
import ShipbluPagination from '../../../layouts/components/ShipbluPagination.vue'
import UploadShipmentsModal from '../components/UploadShipmentsModal.vue'
import i18nData from '../../../i18n/i18nData'

export default {
  data () {
    return {
      common,
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      selected: [],
      productModal: false,
      type: '',
      products: [],
      product: {},
      merchantID: '',
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      searchVal: '',
      searchInProgress: false,
      searchedValue: ' ',
      selectedFlag: false,
      stockRequest: {},
      stockModal: false,
      tableLoader: false,
      printProduct: {},
      merchantStatus: '',
      uploadFileType: '',
      uploadShipmentsModal: false,
      activeTab: '',
      tabs: [
        {
          name: 'Unarchive',
          value: 'unarchive'
        },
        {
          name: 'Archive',
          value: 'archive'
        }
      ]
    }
  },
  watch : {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: this.activeTab,
          page: this.currentPage
        }
      }).catch(() => {})
    },
    selected (val) {
      if (val.length > 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    },
    '$route.query': {
      handler (query) {
        const tab = query.tab || 'unarchive'
        const page = Number(query.page) > 0 ? Number(query.page) : 1

        this.activeTab = tab
        this.currentPage = page
        this.offset = (this.currentPage - 1) * this.maximumItems

        if (this.merchantID) {
          this.loadProductCatalog()
        }
      },
      immediate: true
    }
  },
  methods: {
    changeTab (tab) {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab,
          page: 1
        }
      }).catch(() => {})
    },
    addStockRecall () {
      const stockRecallObj = {
        fulfillment_center: 1,
        products: []
      }
      this.selected.forEach(item => {
        stockRecallObj.products.push({
          product: item.id
        })
      })
      sendFulfillmentRequest(true, false, this, 'api/v1/fc/stock-recalls/', 'post', stockRecallObj, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Stock recall'] + i18nData[this.$i18n.locale][' has been created successfully!'],
            position: 'top-center'
          })
          this.selected = []
          this.loadProductCatalog()
        }
      )
    },
    changePageSize (val) {
      localStorage.setItem('maxItems', val)
      this.maximumItems = val
      this.currentPage = 1
      this.loadProductCatalog()
    },
    loadProductCatalog () {
      this.tableLoader = true
      this.searchInProgress = true
      const query = `?merchant=${this.merchantID}&offset=${this.offset}&search=${this.searchVal}&limit=${this.maximumItems}&archived=${this.activeTab === 'archive'}`
      sendFulfillmentRequest(true, false, this, `api/v1/fc/products/${query}`, 'get', null, true,
        (response) => {
          this.products = response.data.results
          this.totalRows = response.data.count
          this.searchedValue = this.searchVal
          this.tableLoader = false
        }
      )
      this.searchInProgress = false
    },
    openProductModal (type, data) {
      this.type = type
      if (type === 'New Product') {
        this.product = Object.assign({}, {})
        this.product.color = '#000'
      } else {
        this.product = data
        this.product.supplier = this.product.supplier ? this.product.supplier : ''
        this.product.reorder_count = this.product.reorder_count ? this.product.reorder_count : 0
      }
      this.productModal = true
    },
    handleSearch (search) {
      this.offset = 0
      this.currentPage = 1
      this.searchVal = search.target ? search.target.value : search
      return common.manageSearch(search, this.loadProductCatalogSearch)
    },
    loadProductCatalogSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchVal) {
        return
      }
      this.loadProductCatalog()
    },
    printLabel (product) {
      this.printProduct = product
      window.print()
    },
    uploadFiletype (type) {
      this.uploadFileType =  type
      this.uploadShipmentsModal = true
    },
    updateProductArchive (product, archivedValue) {
      this.tableLoader = true
      sendFulfillmentRequest(true, false, this, `api/v1/fc/products/${product.id}/`, 'patch', { archived: archivedValue }, true,
        () => {
          this.$vs.notify({
            color: 'success',
            title: i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Product'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
            position: 'top-center'
          })
          this.loadProductCatalog()
          this.tableLoader = false
        }
      )
    },
    archiveProduct (product) {
      this.updateProductArchive(product, new Date().toISOString())
    },
    unarchiveProduct (product) {
      this.updateProductArchive(product, null)
    },
    downloadCatalog () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#download-btn-loading',
        scale: 0.45
      })
      sendFulfillmentRequest(true, false, this, 'api/v1/fc/products/export/', 'post', {}, true,
        (response) => {
          this.$vs.notify({
            color: 'success',
            title: i18nData[this.$i18n.locale]['Success'],
            text: response.data.message,
            position: 'top-center'
          })
          this.$vs.loading.close('#download-btn-loading > .con-vs-loading')
        }
      )
    }
  },
  components: {
    AddProduct,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    AddStockRequest,
    PrintLabelButton,
    PrintProductBarcode,
    ShipbluPagination,
    UploadShipmentsModal
  },
  mounted () {
    this.$emit('setAppClasses', 'shipment-page')
  },
  created () {
    const merchantData = common.checkMerchantInLocalStorage(this)
    let user = {}
    merchantData.then(results => {
      user = results.merchantData
      this.merchantID = user.id
      this.merchantStatus = user.status
    })
    this.loadProductCatalog()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
#order-label-print{
  display: none;
  visibility: hidden;
}
.con-pagination-table{
  display: none;
}
.color-container {
  border: 1px solid #000;
  border-radius: 7px;
  padding: 2px;
  margin: auto !important;
  div {
    border-radius: 5px;
  }
}
</style>
